import { ProgressSpinner } from "primereact/progressspinner";
import {
  genElDate,
  genElNumber,
  genElObject,
  genElText,
} from "../../../../components/utils/HeaderElementGenerator";

/**
 * The header of the audit: tanggal, kendaraan (and trailer), speedometer and keterangan.
 *
 * showTrailerField: (config) the trailer field is shown next to the kendaraan (trado)
 */
const EditorHeaderCard = ({
  headerData,
  setHeaderData,
  headerError,
  permittedToEdit,
  loading,
  showTrailerField,
  handleOnClickKendaraan,
  handleOnClickTrailer,
}) => {
  /**
   * Generate Header Element
   *
   * various function to generate
   * genElDateRange({ field, name, data, setData, primeFormat, disabled, autoFocus })
   * genElObject({ name, field, value, onClick, onClear, disabled, autoFocus, width })
   */

  // the header can not be changed anymore when the audit has detils
  const hasDetils = headerData?.data_audit_kendaraan_detils?.length > 0;

  const headerElTanggal = genElDate({
    field: "tanggal",
    name: "Tanggal",
    primeFormat: "dd MM yy",
    data: headerData,
    setData: setHeaderData,
    error: headerError,
    showTime: true,
    disabled: !permittedToEdit || hasDetils,
  });

  const headerElVehicle = genElObject({
    name: "Kendaraan",
    field: "data_kendaraan",
    value: headerData.data_kendaraan
      ? `${headerData.data_kendaraan.nomor_polisi} | ${headerData.data_kendaraan.jenis_mobil}`
      : "",
    onClick: handleOnClickKendaraan,
    error: headerError,
    disabled: !permittedToEdit || hasDetils,
  });

  const headerElTrailer = genElObject({
    name: "Trailer",
    field: "data_trailer",
    value: headerData.data_trailer ? `${headerData.data_trailer.nomor}` : "",
    onClick: handleOnClickTrailer,
    error: headerError,
    disabled: !permittedToEdit,
  });

  const headerElSpeedo = genElNumber({
    name: "Speedometer",
    field: "km",
    value: headerData.km ?? 0,
    data: headerData,
    setData: setHeaderData,
    error: headerError,
    disabled: !permittedToEdit || hasDetils,
  });

  const headerElKeterangan = genElText({
    name: "Keterangan",
    field: "keterangan",
    value: headerData.keterangan ?? "",
    data: headerData,
    setData: setHeaderData,
    error: headerError,
    disabled: !permittedToEdit,
  });

  return (
    <div className="elevated-card-tight-vertical !p-0 w-full col-start-start relative wrap gap-3">
      <div className="col-start-start gap-3 w-full px-6 py-4">
        <div className="row-start-center w-full gap-3 flex-wrap sm:flex-nowrap">
          <div className="row-start-start w-full gap-3">{headerElTanggal}</div>
        </div>
        <div className="row-start-center w-full gap-3 flex-wrap sm:flex-nowrap">
          {headerElVehicle}
          {showTrailerField && headerElTrailer}
        </div>
        <div className="row-start-center w-full gap-3 flex-wrap sm:flex-nowrap">
          {headerElSpeedo}
        </div>
        <div className="row-start-center w-full gap-3 flex-wrap sm:flex-nowrap">
          {headerElKeterangan}
        </div>
      </div>
      {loading && (
        <div
          className={`col-center-center w-100  gap-2 absolute z-100 h-100 bg-black/20 rounded `}
        >
          <ProgressSpinner />
        </div>
      )}
    </div>
  );
};

export default EditorHeaderCard;
